import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/logos/logo_variant.png'


const _hoisted_1 = {
  class: "w-72 shrink-0 flex-col border-r border-gray-200 bg-white",
  "aria-label": "Menu",
  "data-testid": "affiliate-sidebar"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex h-20 items-center px-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Minha Escala",
    width: "120"
  })
], -1)
const _hoisted_3 = { class: "mx-4 flex flex-col gap-0.5 rounded-lg border border-lightGray30 px-3 py-2.5 text-left" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-[11px] uppercase tracking-wider text-neutral50" }, "Portal do Afiliado Antecipe", -1)
const _hoisted_5 = {
  class: "font-bold text-primary50",
  "data-testid": "affiliate-sidebar-name"
}
const _hoisted_6 = { class: "text-xs text-[#52526F]" }
const _hoisted_7 = { class: "mt-4 flex-1 px-4" }
const _hoisted_8 = {
  viewBox: "0 0 24 24",
  class: "h-6 w-6 shrink-0",
  fill: "currentColor",
  "aria-hidden": "true"
}
const _hoisted_9 = ["d"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "border-t border-gray-200 p-4 text-left text-xs text-[#7F7F8E]" }, " Valores por plantão, taxas e percentuais individuais não são exibidos neste portal. ", -1)

import { computed } from 'vue'
import type { RouteLocationRaw } from 'vue-router'

import type { AffiliateMeResponse } from '@/Network/Types/Responses/AntecipeAffiliateResponses'

import { AFFILIATE_NAV } from '../labels'
import type { AffiliatePage } from '../labels'


export default /*#__PURE__*/_defineComponent({
  __name: 'AffiliateSidebar',
  props: {
    me: {},
    currentPage: {},
    openCount: {},
    portalLink: { type: Function }
  },
  setup(__props: any) {

const props = __props;



const unitsLabel = computed(() => {
  const count = props.me?.units.length ?? 0
  return `${count} ${count === 1 ? 'unidade vinculada' : 'unidades vinculadas'}`
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.me?.affiliate.name ?? ''), 1),
      _createElementVNode("span", _hoisted_6, _toDisplayString(unitsLabel.value), 1)
    ]),
    _createElementVNode("nav", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(AFFILIATE_NAV), (item) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          key: item.page,
          to: _ctx.portalLink(item.page),
          class: _normalizeClass(["mt-1 flex w-full items-center gap-4 rounded px-5 py-3.5 text-left text-[15px]", 
          item.page === _ctx.currentPage
            ? 'bg-primary30 font-semibold text-white'
            : 'text-textPrimary hover:bg-[rgba(47,127,145,0.08)]'
        ]),
          "aria-current": item.page === _ctx.currentPage ? 'page' : undefined,
          "data-testid": `affiliate-nav-${item.page}`
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("svg", _hoisted_8, [
              _createElementVNode("path", {
                d: item.icon
              }, null, 8, _hoisted_9)
            ])),
            _createElementVNode("span", null, _toDisplayString(item.label), 1),
            (item.page === 'packages' && _ctx.openCount !== null)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(["ml-auto rounded-full px-[7px] text-xs font-semibold", 
            item.page === _ctx.currentPage ? 'bg-white/20 text-white' : 'bg-lightGray30 text-neutral50'
          ])
                }, _toDisplayString(_ctx.openCount), 3))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["to", "class", "aria-current", "data-testid"]))
      }), 128))
    ]),
    _hoisted_10
  ]))
}
}

})